import type { ReactNode } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { CookieConsent } from "./CookieConsent";
import { WhyAvolus } from "./WhyAvolus";
import { NextDriveCTA } from "./NextDriveCTA";

export function Layout({ children, inner = false, showWhyAvolus = true, bookingPage = false }: { children: ReactNode; inner?: boolean; closing?: boolean; showWhyAvolus?: boolean; bookingPage?: boolean }) {
  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <Header />
      <main className={inner ? "flex-1 inner-page" : "flex-1"}>{children}{showWhyAvolus && <WhyAvolus />}<NextDriveCTA callOnly={bookingPage} /></main>
      <Footer />
      <CookieConsent />
    </div>
  );
}
